import { render, staticRenderFns } from "./Tintim.vue?vue&type=template&id=42df2bec&"
import script from "./Tintim.vue?vue&type=script&lang=js&"
export * from "./Tintim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports